module.exports = {
      id: "pdf-usage",
      viewBox: "0 0 21.946 21.946",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#pdf",
      toString: function () {
        return this.url;
      }
    }